/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import Preloader from 'components/preloader';

/**
 * Internal dependencies
 */
import DocumentHead from 'data/document-head';
import { getLoadingCompleted, getLoadingTotal, getLoadingLastLabel } from 'state/loading-progress/selectors';

const LoadingLayout = ({ completed, total, lastLabel }) => (
    <div className='layout'>
        <DocumentHead />
        <Preloader completed={completed} total={total} lastLabel={lastLabel} />
    </div>
);

export default connect((state) => ({
    completed: getLoadingCompleted(state),
    total: getLoadingTotal(state),
    lastLabel: getLoadingLastLabel(state),
}))(LoadingLayout);
